import { IAddKidRequest } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const createChild = async (childData: IAddKidRequest) => {
    return await fetchIStatus<string, IAddKidRequest>(
        '/api/patients/child',
        'POST',
        childData,
    );
};
